import React, { useState, useRef } from "react";
import "./DropdownMenu.css";
import { checkAccess } from "../utils/apiUtils";
import { useHistory } from "react-router-dom";
import { ReactComponent as ArrowIcon } from "./icons/arrow.svg";
import { CSSTransition } from "react-transition-group";

function DropdownMenu(props) {
  const [activeMenu, setActiveMenu] = useState(props.name);
  const [menuHeight, setMenuHeight] = useState(null);
  const dropdownRef = useRef(null);
  const roleId = JSON.parse(sessionStorage.getItem("role_id"))?.role_id;
  const isAdminUser = String(roleId) === "1" || String(roleId) === "2";

  function calcHeight(el) {
    const height = el.offsetHeight;
    setMenuHeight(height);
  }

  function DropdownItem(itemProps) {
    const outsideUrls = [
      "https://www.gstsearch.in/verify.html",
      "https://download.anydesk.com/AnyDesk.exe",
    ];
    const normalizedUrl = itemProps.url?.trim();

    const history = useHistory();

    const handleClick = () => {
      if (typeof itemProps.goToMenu === "string")
        return setActiveMenu(itemProps.goToMenu);

      if (itemProps.goToMenu?.children?.length > 0)
        return setActiveMenu(itemProps.goToMenu.name);

      itemProps.openState(false);

      if (outsideUrls.includes(normalizedUrl)) {
        window.open(normalizedUrl);
        return;
      }

      if (normalizedUrl)
        history.push(normalizedUrl);
    };

    if (itemProps.url) {
      let module = normalizedUrl.replace("/", "").split("?")[0];
      const hasAccess =
        checkAccess(module) ||
        outsideUrls.includes(normalizedUrl);

      if (!hasAccess) return null;
    }

    return (
      <a href="#" className="menu-item" onClick={handleClick}>
        {itemProps.leftIcon && (
          <span className="icon-button">{itemProps.leftIcon}</span>
        )}
        {itemProps.text}
        <span className="icon-right">{itemProps.rightIcon}</span>
      </a>
    );
  }

  return (
    <div
      className="dropdown"
      ref={dropdownRef}
      style={{ height: menuHeight }}
    >
      {/* PRIMARY MENU */}
      <CSSTransition
        in={activeMenu === props.name}
        timeout={250}
        classNames="menu-primary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <div className="menu">
          {props.dropDownMenuItems
            ?.filter((item) => isAdminUser || item?.url !== "/report-bilty?report_type=admin-inward")
            .map((item) => (
            <DropdownItem
              key={item.name}
              text={item.name}
              url={item.url}
              goToMenu={item}
              openState={props.openState}
            />
          ))}
        </div>
      </CSSTransition>

      {/* SECONDARY MENUS */}
      {props.dropDownMenuItems
        ?.filter((item) => isAdminUser || item?.url !== "/report-bilty?report_type=admin-inward")
        .map((item) => (
        <CSSTransition
          key={item.name}
          in={activeMenu === item.name}
          timeout={250}
          classNames="menu-secondary"
          unmountOnExit
          onEnter={calcHeight}
        >
          <div className="menu">
            <DropdownItem
              goToMenu={props.name}
              text={item.name}
              leftIcon={<ArrowIcon />}
              openState={props.openState}
            />

            {item.children
              ?.filter((child) => isAdminUser || child?.url !== "/report-bilty?report_type=admin-inward")
              .map((child) => (
              <DropdownItem
                key={child.name}
                text={child.name}
                url={child.url}
                goToMenu={child}
                openState={props.openState}
              />
            ))}
          </div>
        </CSSTransition>
      ))}
    </div>
  );
}

export default DropdownMenu;
